import {
  productsAPI,
  proposalsAPI,
} from '@/services';

export default {
  SET_TOKEN({ commit }, payload) {
    commit('SET_TOKEN', payload);
  },

  SET_LOADING({ commit }, payload) {
    commit('SET_LOADING', payload);
  },

  SET_SHOW_SURVEY_COMMISSIONS({ commit }, payload) {
    commit('SET_SHOW_SURVEY_COMMISSIONS', payload);
  },

  async SET_STATUSES({ commit, state }) {
    if (!state.token) return;

    await proposalsAPI
      .getStatusList()
      .then(({ data }) => {
        const payload = data.map((status) => ({
          name: status,
          value: status,
        }));
        commit('SET_STATUSES', payload);
      });
  },

  async SET_SUPPLIERS({ commit, state }, product_id) {
    if (!state.token) return;

    await productsAPI
      .getSuppliersList({ product_id })
      .then(({ data }) => {
        const payload = [];
        let arr;

        try {
          if (Array.isArray(data.data)) arr = data.data;
          else {
            arr = Object.values(data.data);
          }

          for (const { id: value, name } of arr) {
            payload.push({ name, value });
          }

          commit('SET_SUPPLIERS', payload);
        } catch {
          // ...
        }
      })
      .catch(() => {
        commit('SET_SUPPLIERS', []);
      });
  },
};
